import { cx } from "./sortBlogs";
import { Link } from "react-router-dom";

const Tag = ({ link = "#", name, ...props }) => {
  return (
    <Link
      to={link} // Replaced 'href' with 'to' for react-router-dom
      className={cx(
        "bg-dark text-light border-light ease inline-block rounded-full border-2 border-solid px-6 py-2 text-sm font-semibold capitalize transition-all duration-200 hover:scale-105 sm:px-10 sm:py-3 sm:text-base",
        props.className,
      )}
    >
      {name}
    </Link>
  );
};

export default Tag;
